export default __webpack_public_path__ + "images/fa12286c71ced0ebef20e9aba2043d99.png";